declare const GLightbox

/**
 * Mass hooks up all needed galleries
 * @param gallerySliderList A list of the gallery elements
 */
export const massHookGalleries = (gallerySliderList: HTMLElement[]): void => {
  gallerySliderList.forEach(gallery => {
    engageGallery(gallery)
  })
}

/**
 * Endgages a single gallery
 * @param gallery The current gallery element
 */
export const engageGallery = (gallery: HTMLElement): void => {
  const galleryTriggers = gallery.querySelectorAll('.js-galleryTrigger') as unknown as HTMLLinkElement[]
  const galleryTriggersList = [...galleryTriggers]
  const galleryItems = [] as {
    href: string
    type: string
  }[]

  galleryTriggers.forEach(trigger => {
    const newItem = {
      href: trigger.href,
      type: 'image'
    }
    galleryItems.push(newItem)

    // Add a trigger to each miniature to load the gallery
    trigger.addEventListener('click', (e) => {
      e.preventDefault()

      // Determine what index we open the gallery on
      const index = galleryTriggersList.findIndex(single => {
        return (single.href === trigger.href)
      })
      myGallery.settings.startAt = index

      // Open the gallery
      myGallery.open()
    })
  })

  // Load the actual gallery
  const myGallery = GLightbox({
    elements: galleryItems
  })
}
